// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file livesoup/v1/realtime.proto (package livesoup.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Transform, Vec3 } from "./common_pb";
import { file_livesoup_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file livesoup/v1/realtime.proto.
 */
export const file_livesoup_v1_realtime: GenFile = /*@__PURE__*/
  fileDesc("ChpsaXZlc291cC92MS9yZWFsdGltZS5wcm90bxILbGl2ZXNvdXAudjEiZAoLQ2xpZW50SW5wdXQSCwoDc2VxGAEgASgNEh4KA3BvcxgCIAEoCzIRLmxpdmVzb3VwLnYxLlZlYzMSCwoDeWF3GAMgASgCEg0KBXBpdGNoGAQgASgCEgwKBGFuaW0YBSABKAkiuQEKDFBsYWNlUmVxdWVzdBITCgtyZXF1ZXN0X3NlcRgBIAEoDRISCgphc3NldF9jb2RlGAIgASgJEh4KA3BvcxgDIAEoCzIRLmxpdmVzb3VwLnYxLlZlYzMSCwoDeWF3GAQgASgCEg0KBXNjYWxlGAUgASgCEg8KB3Bsb3RfaWQYBiABKAkSDAoEcm9sZRgHIAEoCRIMCgR0YWdzGAggAygJEhcKD2NvbXBvbmVudHNfanNvbhgJIAEoCSI3Cg1SZW1vdmVSZXF1ZXN0EhMKC3JlcXVlc3Rfc2VxGAEgASgNEhEKCWVudGl0eV9pZBgCIAEoCSIeCgRQaW5nEhYKDmNsaWVudF90aW1lX21zGAEgASgEIiwKCENoYXRTZW5kEhIKCmNoYW5uZWxfaWQYASABKAkSDAoEYm9keRgCIAEoCSIbCghKb2luUGxvdBIPCgdwbG90X2lkGAEgASgJIhoKCUxlYXZlUGxvdBINCgVlamVjdBgBIAEoCCIdCghJbnRlcmFjdBIRCgllbnRpdHlfaWQYASABKAkiKAoFVXNlT24SDAoEaXRlbRgBIAEoCRIRCgllbnRpdHlfaWQYAiABKAkiCwoJRW50ZXJSb29tIgsKCUxlYXZlUm9vbSLxAwoNQ2xpZW50TWVzc2FnZRIpCgVpbnB1dBgBIAEoCzIYLmxpdmVzb3VwLnYxLkNsaWVudElucHV0SAASKgoFcGxhY2UYAiABKAsyGS5saXZlc291cC52MS5QbGFjZVJlcXVlc3RIABIsCgZyZW1vdmUYAyABKAsyGi5saXZlc291cC52MS5SZW1vdmVSZXF1ZXN0SAASIQoEcGluZxgEIAEoCzIRLmxpdmVzb3VwLnYxLlBpbmdIABIqCgljaGF0X3NlbmQYBSABKAsyFS5saXZlc291cC52MS5DaGF0U2VuZEgAEioKCWpvaW5fcGxvdBgGIAEoCzIVLmxpdmVzb3VwLnYxLkpvaW5QbG90SAASLAoKbGVhdmVfcGxvdBgHIAEoCzIWLmxpdmVzb3VwLnYxLkxlYXZlUGxvdEgAEikKCGludGVyYWN0GAggASgLMhUubGl2ZXNvdXAudjEuSW50ZXJhY3RIABIkCgZ1c2Vfb24YCSABKAsyEi5saXZlc291cC52MS5Vc2VPbkgAEiwKCmVudGVyX3Jvb20YCiABKAsyFi5saXZlc291cC52MS5FbnRlclJvb21IABIsCgpsZWF2ZV9yb29tGAsgASgLMhYubGl2ZXNvdXAudjEuTGVhdmVSb29tSABCBQoDbXNnIpsBCgtQbGF5ZXJTdGF0ZRIKCgJpZBgBIAEoCRIUCgxkaXNwbGF5X25hbWUYAiABKAkSDQoFY29sb3IYAyABKA0SHgoDcG9zGAQgASgLMhEubGl2ZXNvdXAudjEuVmVjMxILCgN5YXcYBSABKAISDQoFcGl0Y2gYBiABKAISDAoEYW5pbRgHIAEoCRIRCglpbnB1dF9zZXEYCCABKA0iRAoLRW50aXR5U3RhdGUSCgoCaWQYASABKAkSKQoJdHJhbnNmb3JtGAIgASgLMhYubGl2ZXNvdXAudjEuVHJhbnNmb3JtIpsCCgZFbnRpdHkSCgoCaWQYASABKAkSEgoKYXNzZXRfY29kZRgCIAEoCRIpCgl0cmFuc2Zvcm0YAyABKAsyFi5saXZlc291cC52MS5UcmFuc2Zvcm0SDwoHcGxvdF9pZBgEIAEoCRINCgVzdGFnZRgFIAEoCRIMCgRyb2xlGAYgASgJEgwKBHRhZ3MYByADKAkSFwoPY29tcG9uZW50c19qc29uGAggASgJEhIKCm93bmVyX25hbWUYCSABKAkSFgoOcGxhY2VkX2J5X25hbWUYCiABKAkSDwoHbGljZW5zZRgLIAEoCRIMCgRuYW1lGAwgASgJEhQKDHBsYWNlZF9ieV9pZBgNIAEoCRIQCghvd25lcl9pZBgOIAEoCSKsAQoHV2VsY29tZRIRCglwbGF5ZXJfaWQYASABKAkSGAoQcHJvdG9jb2xfdmVyc2lvbhgCIAEoDRIZChF3b3JsZF9jb25maWdfaGFzaBgDIAEoCRIgCgVzcGF3bhgEIAEoCzIRLmxpdmVzb3VwLnYxLlZlYzMSEQoJc3Bhd25feWF3GAUgASgCEhMKC3NlcnZlcl90aWNrGAYgASgEEg8KB3RpY2tfaHoYByABKA0iGQoHR29vZGJ5ZRIOCgZyZWFzb24YASABKAkicwoMWm9uZVNuYXBzaG90EgwKBHRpY2sYASABKAQSKQoHcGxheWVycxgCIAMoCzIYLmxpdmVzb3VwLnYxLlBsYXllclN0YXRlEioKCGVudGl0aWVzGAMgAygLMhgubGl2ZXNvdXAudjEuRW50aXR5U3RhdGUiOAoMUGxheWVySm9pbmVkEigKBnBsYXllchgBIAEoCzIYLmxpdmVzb3VwLnYxLlBsYXllclN0YXRlIhgKClBsYXllckxlZnQSCgoCaWQYASABKAkiMgoLRW50aXR5QWRkZWQSIwoGZW50aXR5GAEgASgLMhMubGl2ZXNvdXAudjEuRW50aXR5IiIKDUVudGl0eVJlbW92ZWQSEQoJZW50aXR5X2lkGAEgASgJIjwKCkNvcnJlY3Rpb24SHgoDcG9zGAEgASgLMhEubGl2ZXNvdXAudjEuVmVjMxIOCgZyZWFzb24YAiABKAkiOwoFRXJyb3ISDAoEY29kZRgBIAEoCRIPCgdtZXNzYWdlGAIgASgJEhMKC3JlcXVlc3Rfc2VxGAMgASgNIjYKBFBvbmcSFgoOY2xpZW50X3RpbWVfbXMYASABKAQSFgoOc2VydmVyX3RpbWVfbXMYAiABKAQiqAEKC0NoYXRNZXNzYWdlEgoKAmlkGAEgASgJEhIKCmNoYW5uZWxfaWQYAiABKAkSEQoJc2VuZGVyX2lkGAMgASgJEhMKC3NlbmRlcl9uYW1lGAQgASgJEgwKBGtpbmQYBSABKAkSDAoEYm9keRgGIAEoCRIVCg1jcmVhdGVkX2F0X21zGAcgASgDEh4KA3BvcxgIIAEoCzIRLmxpdmVzb3VwLnYxLlZlYzMiZgoMUGxvdFByZXNlbmNlEg8KB3Bsb3RfaWQYASABKAkSDAoEbmFtZRgCIAEoCRISCgpvd25lcl9uYW1lGAMgASgJEhQKDGNvbnNlbnRfbW9kZRgEIAEoCRINCgVzdGF0ZRgFIAEoCSJVCgpXb3JsZEV2ZW50EgwKBGtpbmQYASABKAkSEQoJZW50aXR5X2lkGAIgASgJEhEKCXBsYXllcl9pZBgDIAEoCRITCgtwYXJhbXNfanNvbhgEIAEoCSIZCglVSUNvbW1hbmQSDAoEanNvbhgBIAEoCSI2CgxEcmFmdFVwZGF0ZWQSDwoHcGxvdF9pZBgBIAEoCRIVCg1kcmFmdF92ZXJzaW9uGAIgASgFIg4KDFBsb3RzQ2hhbmdlZCIhCg5NYXJrZXJzQ2hhbmdlZBIPCgdwbG90X2lkGAEgASgJIk0KC0NoYXRIaXN0b3J5EhIKCmNoYW5uZWxfaWQYASABKAkSKgoIbWVzc2FnZXMYAiADKAsyGC5saXZlc291cC52MS5DaGF0TWVzc2FnZSItCgtDaGF0RGVsZXRlZBIKCgJpZBgBIAEoCRISCgpjaGFubmVsX2lkGAIgASgJIh8KC01haWxDaGFuZ2VkEhAKCGFnZW50X2lkGAEgASgJIg8KDUFzc2V0c0NoYW5nZWQiyQcKDVNlcnZlck1lc3NhZ2USJwoHd2VsY29tZRgBIAEoCzIULmxpdmVzb3VwLnYxLldlbGNvbWVIABInCgdnb29kYnllGAIgASgLMhQubGl2ZXNvdXAudjEuR29vZGJ5ZUgAEi0KCHNuYXBzaG90GAMgASgLMhkubGl2ZXNvdXAudjEuWm9uZVNuYXBzaG90SAASKwoGam9pbmVkGAQgASgLMhkubGl2ZXNvdXAudjEuUGxheWVySm9pbmVkSAASJwoEbGVmdBgFIAEoCzIXLmxpdmVzb3VwLnYxLlBsYXllckxlZnRIABIwCgxlbnRpdHlfYWRkZWQYBiABKAsyGC5saXZlc291cC52MS5FbnRpdHlBZGRlZEgAEjQKDmVudGl0eV9yZW1vdmVkGAcgASgLMhoubGl2ZXNvdXAudjEuRW50aXR5UmVtb3ZlZEgAEi0KCmNvcnJlY3Rpb24YCCABKAsyFy5saXZlc291cC52MS5Db3JyZWN0aW9uSAASIwoFZXJyb3IYCSABKAsyEi5saXZlc291cC52MS5FcnJvckgAEiEKBHBvbmcYCiABKAsyES5saXZlc291cC52MS5Qb25nSAASKAoEY2hhdBgLIAEoCzIYLmxpdmVzb3VwLnYxLkNoYXRNZXNzYWdlSAASLQoIcHJlc2VuY2UYDCABKAsyGS5saXZlc291cC52MS5QbG90UHJlc2VuY2VIABIoCgVldmVudBgNIAEoCzIXLmxpdmVzb3VwLnYxLldvcmxkRXZlbnRIABIkCgJ1aRgOIAEoCzIWLmxpdmVzb3VwLnYxLlVJQ29tbWFuZEgAEioKBWRyYWZ0GA8gASgLMhkubGl2ZXNvdXAudjEuRHJhZnRVcGRhdGVkSAASMgoNcGxvdHNfY2hhbmdlZBgQIAEoCzIZLmxpdmVzb3VwLnYxLlBsb3RzQ2hhbmdlZEgAEi4KB21hcmtlcnMYESABKAsyGy5saXZlc291cC52MS5NYXJrZXJzQ2hhbmdlZEgAEjAKDGNoYXRfaGlzdG9yeRgSIAEoCzIYLmxpdmVzb3VwLnYxLkNoYXRIaXN0b3J5SAASMAoMY2hhdF9kZWxldGVkGBMgASgLMhgubGl2ZXNvdXAudjEuQ2hhdERlbGV0ZWRIABIoCgRtYWlsGBQgASgLMhgubGl2ZXNvdXAudjEuTWFpbENoYW5nZWRIABI0Cg5hc3NldHNfY2hhbmdlZBgVIAEoCzIaLmxpdmVzb3VwLnYxLkFzc2V0c0NoYW5nZWRIAEIFCgNtc2dCLFoqbGl2ZXNvdXAvc2VydmVyL2dlbi9saXZlc291cC92MTtsaXZlc291cHYxYgZwcm90bzM", [file_livesoup_v1_common]);

/**
 * @generated from message livesoup.v1.ClientInput
 */
export type ClientInput = Message<"livesoup.v1.ClientInput"> & {
  /**
   * @generated from field: uint32 seq = 1;
   */
  seq: number;

  /**
   * @generated from field: livesoup.v1.Vec3 pos = 2;
   */
  pos?: Vec3 | undefined;

  /**
   * @generated from field: float yaw = 3;
   */
  yaw: number;

  /**
   * @generated from field: float pitch = 4;
   */
  pitch: number;

  /**
   * idle|walk|run|jump
   *
   * @generated from field: string anim = 5;
   */
  anim: string;
};

/**
 * Describes the message livesoup.v1.ClientInput.
 * Use `create(ClientInputSchema)` to create a new message.
 */
export const ClientInputSchema: GenMessage<ClientInput> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 0);

/**
 * @generated from message livesoup.v1.PlaceRequest
 */
export type PlaceRequest = Message<"livesoup.v1.PlaceRequest"> & {
  /**
   * @generated from field: uint32 request_seq = 1;
   */
  requestSeq: number;

  /**
   * empty when components_json has "primitive"
   *
   * @generated from field: string asset_code = 2;
   */
  assetCode: string;

  /**
   * @generated from field: livesoup.v1.Vec3 pos = 3;
   */
  pos?: Vec3 | undefined;

  /**
   * @generated from field: float yaw = 4;
   */
  yaw: number;

  /**
   * @generated from field: float scale = 5;
   */
  scale: number;

  /**
   * @generated from field: string plot_id = 6;
   */
  plotId: string;

  /**
   * @generated from field: string role = 7;
   */
  role: string;

  /**
   * @generated from field: repeated string tags = 8;
   */
  tags: string[];

  /**
   * "{}" or a JSON object
   *
   * @generated from field: string components_json = 9;
   */
  componentsJson: string;
};

/**
 * Describes the message livesoup.v1.PlaceRequest.
 * Use `create(PlaceRequestSchema)` to create a new message.
 */
export const PlaceRequestSchema: GenMessage<PlaceRequest> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 1);

/**
 * @generated from message livesoup.v1.RemoveRequest
 */
export type RemoveRequest = Message<"livesoup.v1.RemoveRequest"> & {
  /**
   * @generated from field: uint32 request_seq = 1;
   */
  requestSeq: number;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;
};

/**
 * Describes the message livesoup.v1.RemoveRequest.
 * Use `create(RemoveRequestSchema)` to create a new message.
 */
export const RemoveRequestSchema: GenMessage<RemoveRequest> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 2);

/**
 * @generated from message livesoup.v1.Ping
 */
export type Ping = Message<"livesoup.v1.Ping"> & {
  /**
   * @generated from field: uint64 client_time_ms = 1;
   */
  clientTimeMs: bigint;
};

/**
 * Describes the message livesoup.v1.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema: GenMessage<Ping> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 3);

/**
 * @generated from message livesoup.v1.ChatSend
 */
export type ChatSend = Message<"livesoup.v1.ChatSend"> & {
  /**
   * empty = proximity
   *
   * @generated from field: string channel_id = 1;
   */
  channelId: string;

  /**
   * @generated from field: string body = 2;
   */
  body: string;
};

/**
 * Describes the message livesoup.v1.ChatSend.
 * Use `create(ChatSendSchema)` to create a new message.
 */
export const ChatSendSchema: GenMessage<ChatSend> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 4);

/**
 * @generated from message livesoup.v1.JoinPlot
 */
export type JoinPlot = Message<"livesoup.v1.JoinPlot"> & {
  /**
   * @generated from field: string plot_id = 1;
   */
  plotId: string;
};

/**
 * Describes the message livesoup.v1.JoinPlot.
 * Use `create(JoinPlotSchema)` to create a new message.
 */
export const JoinPlotSchema: GenMessage<JoinPlot> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 5);

/**
 * @generated from message livesoup.v1.LeavePlot
 */
export type LeavePlot = Message<"livesoup.v1.LeavePlot"> & {
  /**
   * false: leave the joined state (back to inside). true: the server moves the player 2 m outside
   * the nearest edge and sends Correction{reason: LEAVE_PLOT} (spec §15.2).
   *
   * @generated from field: bool eject = 1;
   */
  eject: boolean;
};

/**
 * Describes the message livesoup.v1.LeavePlot.
 * Use `create(LeavePlotSchema)` to create a new message.
 */
export const LeavePlotSchema: GenMessage<LeavePlot> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 6);

/**
 * @generated from message livesoup.v1.Interact
 */
export type Interact = Message<"livesoup.v1.Interact"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message livesoup.v1.Interact.
 * Use `create(InteractSchema)` to create a new message.
 */
export const InteractSchema: GenMessage<Interact> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 7);

/**
 * @generated from message livesoup.v1.UseOn
 */
export type UseOn = Message<"livesoup.v1.UseOn"> & {
  /**
   * @generated from field: string item = 1;
   */
  item: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;
};

/**
 * Describes the message livesoup.v1.UseOn.
 * Use `create(UseOnSchema)` to create a new message.
 */
export const UseOnSchema: GenMessage<UseOn> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 8);

/**
 * The player goes to their own room: out of the world, connection kept (spec 2o §3.7).
 *
 * @generated from message livesoup.v1.EnterRoom
 */
export type EnterRoom = Message<"livesoup.v1.EnterRoom"> & {
};

/**
 * Describes the message livesoup.v1.EnterRoom.
 * Use `create(EnterRoomSchema)` to create a new message.
 */
export const EnterRoomSchema: GenMessage<EnterRoom> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 9);

/**
 * Back from the room to where the server saw the player last.
 *
 * @generated from message livesoup.v1.LeaveRoom
 */
export type LeaveRoom = Message<"livesoup.v1.LeaveRoom"> & {
};

/**
 * Describes the message livesoup.v1.LeaveRoom.
 * Use `create(LeaveRoomSchema)` to create a new message.
 */
export const LeaveRoomSchema: GenMessage<LeaveRoom> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 10);

/**
 * @generated from message livesoup.v1.ClientMessage
 */
export type ClientMessage = Message<"livesoup.v1.ClientMessage"> & {
  /**
   * @generated from oneof livesoup.v1.ClientMessage.msg
   */
  msg: {
    /**
     * @generated from field: livesoup.v1.ClientInput input = 1;
     */
    value: ClientInput;
    case: "input";
  } | {
    /**
     * @generated from field: livesoup.v1.PlaceRequest place = 2;
     */
    value: PlaceRequest;
    case: "place";
  } | {
    /**
     * @generated from field: livesoup.v1.RemoveRequest remove = 3;
     */
    value: RemoveRequest;
    case: "remove";
  } | {
    /**
     * @generated from field: livesoup.v1.Ping ping = 4;
     */
    value: Ping;
    case: "ping";
  } | {
    /**
     * @generated from field: livesoup.v1.ChatSend chat_send = 5;
     */
    value: ChatSend;
    case: "chatSend";
  } | {
    /**
     * @generated from field: livesoup.v1.JoinPlot join_plot = 6;
     */
    value: JoinPlot;
    case: "joinPlot";
  } | {
    /**
     * @generated from field: livesoup.v1.LeavePlot leave_plot = 7;
     */
    value: LeavePlot;
    case: "leavePlot";
  } | {
    /**
     * @generated from field: livesoup.v1.Interact interact = 8;
     */
    value: Interact;
    case: "interact";
  } | {
    /**
     * @generated from field: livesoup.v1.UseOn use_on = 9;
     */
    value: UseOn;
    case: "useOn";
  } | {
    /**
     * @generated from field: livesoup.v1.EnterRoom enter_room = 10;
     */
    value: EnterRoom;
    case: "enterRoom";
  } | {
    /**
     * @generated from field: livesoup.v1.LeaveRoom leave_room = 11;
     */
    value: LeaveRoom;
    case: "leaveRoom";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message livesoup.v1.ClientMessage.
 * Use `create(ClientMessageSchema)` to create a new message.
 */
export const ClientMessageSchema: GenMessage<ClientMessage> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 11);

/**
 * @generated from message livesoup.v1.PlayerState
 */
export type PlayerState = Message<"livesoup.v1.PlayerState"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * 0xRRGGBB
   *
   * @generated from field: uint32 color = 3;
   */
  color: number;

  /**
   * @generated from field: livesoup.v1.Vec3 pos = 4;
   */
  pos?: Vec3 | undefined;

  /**
   * @generated from field: float yaw = 5;
   */
  yaw: number;

  /**
   * @generated from field: float pitch = 6;
   */
  pitch: number;

  /**
   * @generated from field: string anim = 7;
   */
  anim: string;

  /**
   * last accepted input
   *
   * @generated from field: uint32 input_seq = 8;
   */
  inputSeq: number;
};

/**
 * Describes the message livesoup.v1.PlayerState.
 * Use `create(PlayerStateSchema)` to create a new message.
 */
export const PlayerStateSchema: GenMessage<PlayerState> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 12);

/**
 * @generated from message livesoup.v1.EntityState
 */
export type EntityState = Message<"livesoup.v1.EntityState"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: livesoup.v1.Transform transform = 2;
   */
  transform?: Transform | undefined;
};

/**
 * Describes the message livesoup.v1.EntityState.
 * Use `create(EntityStateSchema)` to create a new message.
 */
export const EntityStateSchema: GenMessage<EntityState> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 13);

/**
 * @generated from message livesoup.v1.Entity
 */
export type Entity = Message<"livesoup.v1.Entity"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string asset_code = 2;
   */
  assetCode: string;

  /**
   * @generated from field: livesoup.v1.Transform transform = 3;
   */
  transform?: Transform | undefined;

  /**
   * @generated from field: string plot_id = 4;
   */
  plotId: string;

  /**
   * live|draft
   *
   * @generated from field: string stage = 5;
   */
  stage: string;

  /**
   * @generated from field: string role = 6;
   */
  role: string;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * @generated from field: string components_json = 8;
   */
  componentsJson: string;

  /**
   * @generated from field: string owner_name = 9;
   */
  ownerName: string;

  /**
   * @generated from field: string placed_by_name = 10;
   */
  placedByName: string;

  /**
   * @generated from field: string license = 11;
   */
  license: string;

  /**
   * @generated from field: string name = 12;
   */
  name: string;

  /**
   * @generated from field: string placed_by_id = 13;
   */
  placedById: string;

  /**
   * @generated from field: string owner_id = 14;
   */
  ownerId: string;
};

/**
 * Describes the message livesoup.v1.Entity.
 * Use `create(EntitySchema)` to create a new message.
 */
export const EntitySchema: GenMessage<Entity> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 14);

/**
 * @generated from message livesoup.v1.Welcome
 */
export type Welcome = Message<"livesoup.v1.Welcome"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * @generated from field: uint32 protocol_version = 2;
   */
  protocolVersion: number;

  /**
   * @generated from field: string world_config_hash = 3;
   */
  worldConfigHash: string;

  /**
   * @generated from field: livesoup.v1.Vec3 spawn = 4;
   */
  spawn?: Vec3 | undefined;

  /**
   * @generated from field: float spawn_yaw = 5;
   */
  spawnYaw: number;

  /**
   * @generated from field: uint64 server_tick = 6;
   */
  serverTick: bigint;

  /**
   * @generated from field: uint32 tick_hz = 7;
   */
  tickHz: number;
};

/**
 * Describes the message livesoup.v1.Welcome.
 * Use `create(WelcomeSchema)` to create a new message.
 */
export const WelcomeSchema: GenMessage<Welcome> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 15);

/**
 * @generated from message livesoup.v1.Goodbye
 */
export type Goodbye = Message<"livesoup.v1.Goodbye"> & {
  /**
   * PROTOCOL_MISMATCH|REPLACED|SLOW_CONSUMER|SHUTDOWN
   *
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message livesoup.v1.Goodbye.
 * Use `create(GoodbyeSchema)` to create a new message.
 */
export const GoodbyeSchema: GenMessage<Goodbye> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 16);

/**
 * @generated from message livesoup.v1.ZoneSnapshot
 */
export type ZoneSnapshot = Message<"livesoup.v1.ZoneSnapshot"> & {
  /**
   * @generated from field: uint64 tick = 1;
   */
  tick: bigint;

  /**
   * @generated from field: repeated livesoup.v1.PlayerState players = 2;
   */
  players: PlayerState[];

  /**
   * @generated from field: repeated livesoup.v1.EntityState entities = 3;
   */
  entities: EntityState[];
};

/**
 * Describes the message livesoup.v1.ZoneSnapshot.
 * Use `create(ZoneSnapshotSchema)` to create a new message.
 */
export const ZoneSnapshotSchema: GenMessage<ZoneSnapshot> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 17);

/**
 * @generated from message livesoup.v1.PlayerJoined
 */
export type PlayerJoined = Message<"livesoup.v1.PlayerJoined"> & {
  /**
   * @generated from field: livesoup.v1.PlayerState player = 1;
   */
  player?: PlayerState | undefined;
};

/**
 * Describes the message livesoup.v1.PlayerJoined.
 * Use `create(PlayerJoinedSchema)` to create a new message.
 */
export const PlayerJoinedSchema: GenMessage<PlayerJoined> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 18);

/**
 * @generated from message livesoup.v1.PlayerLeft
 */
export type PlayerLeft = Message<"livesoup.v1.PlayerLeft"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message livesoup.v1.PlayerLeft.
 * Use `create(PlayerLeftSchema)` to create a new message.
 */
export const PlayerLeftSchema: GenMessage<PlayerLeft> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 19);

/**
 * @generated from message livesoup.v1.EntityAdded
 */
export type EntityAdded = Message<"livesoup.v1.EntityAdded"> & {
  /**
   * @generated from field: livesoup.v1.Entity entity = 1;
   */
  entity?: Entity | undefined;
};

/**
 * Describes the message livesoup.v1.EntityAdded.
 * Use `create(EntityAddedSchema)` to create a new message.
 */
export const EntityAddedSchema: GenMessage<EntityAdded> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 20);

/**
 * @generated from message livesoup.v1.EntityRemoved
 */
export type EntityRemoved = Message<"livesoup.v1.EntityRemoved"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message livesoup.v1.EntityRemoved.
 * Use `create(EntityRemovedSchema)` to create a new message.
 */
export const EntityRemovedSchema: GenMessage<EntityRemoved> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 21);

/**
 * @generated from message livesoup.v1.Correction
 */
export type Correction = Message<"livesoup.v1.Correction"> & {
  /**
   * @generated from field: livesoup.v1.Vec3 pos = 1;
   */
  pos?: Vec3 | undefined;

  /**
   * SPEED|HEIGHT|BOUNDS|INVALID|LEAVE_PLOT
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message livesoup.v1.Correction.
 * Use `create(CorrectionSchema)` to create a new message.
 */
export const CorrectionSchema: GenMessage<Correction> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 22);

/**
 * @generated from message livesoup.v1.Error
 */
export type Error = Message<"livesoup.v1.Error"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: uint32 request_seq = 3;
   */
  requestSeq: number;
};

/**
 * Describes the message livesoup.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 23);

/**
 * @generated from message livesoup.v1.Pong
 */
export type Pong = Message<"livesoup.v1.Pong"> & {
  /**
   * @generated from field: uint64 client_time_ms = 1;
   */
  clientTimeMs: bigint;

  /**
   * @generated from field: uint64 server_time_ms = 2;
   */
  serverTimeMs: bigint;
};

/**
 * Describes the message livesoup.v1.Pong.
 * Use `create(PongSchema)` to create a new message.
 */
export const PongSchema: GenMessage<Pong> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 24);

/**
 * @generated from message livesoup.v1.ChatMessage
 */
export type ChatMessage = Message<"livesoup.v1.ChatMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string channel_id = 2;
   */
  channelId: string;

  /**
   * @generated from field: string sender_id = 3;
   */
  senderId: string;

  /**
   * @generated from field: string sender_name = 4;
   */
  senderName: string;

  /**
   * user|system
   *
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * @generated from field: string body = 6;
   */
  body: string;

  /**
   * @generated from field: int64 created_at_ms = 7;
   */
  createdAtMs: bigint;

  /**
   * proximity messages only: where the sender stood (spec 2i §4.4)
   *
   * @generated from field: livesoup.v1.Vec3 pos = 8;
   */
  pos?: Vec3 | undefined;
};

/**
 * Describes the message livesoup.v1.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 25);

/**
 * @generated from message livesoup.v1.PlotPresence
 */
export type PlotPresence = Message<"livesoup.v1.PlotPresence"> & {
  /**
   * @generated from field: string plot_id = 1;
   */
  plotId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string owner_name = 3;
   */
  ownerName: string;

  /**
   * @generated from field: string consent_mode = 4;
   */
  consentMode: string;

  /**
   * outside|inside|joined
   *
   * @generated from field: string state = 5;
   */
  state: string;
};

/**
 * Describes the message livesoup.v1.PlotPresence.
 * Use `create(PlotPresenceSchema)` to create a new message.
 */
export const PlotPresenceSchema: GenMessage<PlotPresence> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 26);

/**
 * @generated from message livesoup.v1.WorldEvent
 */
export type WorldEvent = Message<"livesoup.v1.WorldEvent"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string player_id = 3;
   */
  playerId: string;

  /**
   * @generated from field: string params_json = 4;
   */
  paramsJson: string;
};

/**
 * Describes the message livesoup.v1.WorldEvent.
 * Use `create(WorldEventSchema)` to create a new message.
 */
export const WorldEventSchema: GenMessage<WorldEvent> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 27);

/**
 * @generated from message livesoup.v1.UICommand
 */
export type UICommand = Message<"livesoup.v1.UICommand"> & {
  /**
   * @generated from field: string json = 1;
   */
  json: string;
};

/**
 * Describes the message livesoup.v1.UICommand.
 * Use `create(UICommandSchema)` to create a new message.
 */
export const UICommandSchema: GenMessage<UICommand> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 28);

/**
 * @generated from message livesoup.v1.DraftUpdated
 */
export type DraftUpdated = Message<"livesoup.v1.DraftUpdated"> & {
  /**
   * @generated from field: string plot_id = 1;
   */
  plotId: string;

  /**
   * @generated from field: int32 draft_version = 2;
   */
  draftVersion: number;
};

/**
 * Describes the message livesoup.v1.DraftUpdated.
 * Use `create(DraftUpdatedSchema)` to create a new message.
 */
export const DraftUpdatedSchema: GenMessage<DraftUpdated> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 29);

/**
 * A plot was claimed, abandoned or renamed; clients re-fetch /v1/plots.
 *
 * @generated from message livesoup.v1.PlotsChanged
 */
export type PlotsChanged = Message<"livesoup.v1.PlotsChanged"> & {
};

/**
 * Describes the message livesoup.v1.PlotsChanged.
 * Use `create(PlotsChangedSchema)` to create a new message.
 */
export const PlotsChangedSchema: GenMessage<PlotsChanged> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 30);

/**
 * MarkersChanged: a marker on this plot was created, edited, resolved or deleted; members re-read
 * GET /v1/plots/{id}/markers (spec 2h §3.4).
 *
 * @generated from message livesoup.v1.MarkersChanged
 */
export type MarkersChanged = Message<"livesoup.v1.MarkersChanged"> & {
  /**
   * @generated from field: string plot_id = 1;
   */
  plotId: string;
};

/**
 * Describes the message livesoup.v1.MarkersChanged.
 * Use `create(MarkersChangedSchema)` to create a new message.
 */
export const MarkersChangedSchema: GenMessage<MarkersChanged> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 31);

/**
 * ChatHistory: a channel's recent messages, oldest first, sent when a connection starts following it
 * (spec 2i §4.5).
 *
 * @generated from message livesoup.v1.ChatHistory
 */
export type ChatHistory = Message<"livesoup.v1.ChatHistory"> & {
  /**
   * @generated from field: string channel_id = 1;
   */
  channelId: string;

  /**
   * @generated from field: repeated livesoup.v1.ChatMessage messages = 2;
   */
  messages: ChatMessage[];
};

/**
 * Describes the message livesoup.v1.ChatHistory.
 * Use `create(ChatHistorySchema)` to create a new message.
 */
export const ChatHistorySchema: GenMessage<ChatHistory> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 32);

/**
 * ChatDeleted: an admin removed a global message; clients drop it (spec 2i §4.3).
 *
 * @generated from message livesoup.v1.ChatDeleted
 */
export type ChatDeleted = Message<"livesoup.v1.ChatDeleted"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string channel_id = 2;
   */
  channelId: string;
};

/**
 * Describes the message livesoup.v1.ChatDeleted.
 * Use `create(ChatDeletedSchema)` to create a new message.
 */
export const ChatDeletedSchema: GenMessage<ChatDeleted> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 33);

/**
 * MailChanged: the owner's thread with this agent changed (a message, a read, or the agent checked its
 * mail); the owner re-reads GET /v1/me/mail (spec 2j §3.5). Sent on the owner's account topic only.
 *
 * @generated from message livesoup.v1.MailChanged
 */
export type MailChanged = Message<"livesoup.v1.MailChanged"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;
};

/**
 * Describes the message livesoup.v1.MailChanged.
 * Use `create(MailChangedSchema)` to create a new message.
 */
export const MailChangedSchema: GenMessage<MailChanged> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 34);

/**
 * The account gained or lost assets: re-read /v1/me/assets (spec 2o §3.6).
 *
 * @generated from message livesoup.v1.AssetsChanged
 */
export type AssetsChanged = Message<"livesoup.v1.AssetsChanged"> & {
};

/**
 * Describes the message livesoup.v1.AssetsChanged.
 * Use `create(AssetsChangedSchema)` to create a new message.
 */
export const AssetsChangedSchema: GenMessage<AssetsChanged> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 35);

/**
 * @generated from message livesoup.v1.ServerMessage
 */
export type ServerMessage = Message<"livesoup.v1.ServerMessage"> & {
  /**
   * @generated from oneof livesoup.v1.ServerMessage.msg
   */
  msg: {
    /**
     * @generated from field: livesoup.v1.Welcome welcome = 1;
     */
    value: Welcome;
    case: "welcome";
  } | {
    /**
     * @generated from field: livesoup.v1.Goodbye goodbye = 2;
     */
    value: Goodbye;
    case: "goodbye";
  } | {
    /**
     * @generated from field: livesoup.v1.ZoneSnapshot snapshot = 3;
     */
    value: ZoneSnapshot;
    case: "snapshot";
  } | {
    /**
     * @generated from field: livesoup.v1.PlayerJoined joined = 4;
     */
    value: PlayerJoined;
    case: "joined";
  } | {
    /**
     * @generated from field: livesoup.v1.PlayerLeft left = 5;
     */
    value: PlayerLeft;
    case: "left";
  } | {
    /**
     * @generated from field: livesoup.v1.EntityAdded entity_added = 6;
     */
    value: EntityAdded;
    case: "entityAdded";
  } | {
    /**
     * @generated from field: livesoup.v1.EntityRemoved entity_removed = 7;
     */
    value: EntityRemoved;
    case: "entityRemoved";
  } | {
    /**
     * @generated from field: livesoup.v1.Correction correction = 8;
     */
    value: Correction;
    case: "correction";
  } | {
    /**
     * @generated from field: livesoup.v1.Error error = 9;
     */
    value: Error;
    case: "error";
  } | {
    /**
     * @generated from field: livesoup.v1.Pong pong = 10;
     */
    value: Pong;
    case: "pong";
  } | {
    /**
     * @generated from field: livesoup.v1.ChatMessage chat = 11;
     */
    value: ChatMessage;
    case: "chat";
  } | {
    /**
     * @generated from field: livesoup.v1.PlotPresence presence = 12;
     */
    value: PlotPresence;
    case: "presence";
  } | {
    /**
     * @generated from field: livesoup.v1.WorldEvent event = 13;
     */
    value: WorldEvent;
    case: "event";
  } | {
    /**
     * @generated from field: livesoup.v1.UICommand ui = 14;
     */
    value: UICommand;
    case: "ui";
  } | {
    /**
     * @generated from field: livesoup.v1.DraftUpdated draft = 15;
     */
    value: DraftUpdated;
    case: "draft";
  } | {
    /**
     * @generated from field: livesoup.v1.PlotsChanged plots_changed = 16;
     */
    value: PlotsChanged;
    case: "plotsChanged";
  } | {
    /**
     * @generated from field: livesoup.v1.MarkersChanged markers = 17;
     */
    value: MarkersChanged;
    case: "markers";
  } | {
    /**
     * @generated from field: livesoup.v1.ChatHistory chat_history = 18;
     */
    value: ChatHistory;
    case: "chatHistory";
  } | {
    /**
     * @generated from field: livesoup.v1.ChatDeleted chat_deleted = 19;
     */
    value: ChatDeleted;
    case: "chatDeleted";
  } | {
    /**
     * @generated from field: livesoup.v1.MailChanged mail = 20;
     */
    value: MailChanged;
    case: "mail";
  } | {
    /**
     * @generated from field: livesoup.v1.AssetsChanged assets_changed = 21;
     */
    value: AssetsChanged;
    case: "assetsChanged";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message livesoup.v1.ServerMessage.
 * Use `create(ServerMessageSchema)` to create a new message.
 */
export const ServerMessageSchema: GenMessage<ServerMessage> = /*@__PURE__*/
  messageDesc(file_livesoup_v1_realtime, 36);

